export default __webpack_public_path__ + "static/mylos-monsters-cover-8e2034579a3dad8a896d66c0dc848db0.jpg";